export enum DOStages {
    PRELOADER = 0,
    MAIN_GAME = 1,
    BONUS_TREASURE = 2,
    FREE_SPIN = 3
}

export enum DOScenes {
    FREESPIN = 'freespins',
    FREESPIN_TO_DEFAULT = 'freespins_to_default',
    BONUS_TO_DEFAULT = 'bonus_to_default',
    TREASURE_BONUS = 'bonus',
    DEFAULT = 'default',
    INTRO = 'intro',
    BONUS_GAME = 'bonus_game'
}

export enum GameType {
    default = 'default',
    freeSpin = 'freespins',
    bonusGame = 'bonusGame',
    treasureBonus = 'treasureBonus'
}

export enum DOPrompts {
    RETRIGGER_FREESPIN = 'freespins_retrigger',
    EXIT_FREESPIN = 'exit_freespins',
    ENTER_FREESPIN = 'enter_freespins',
    EXIT_TREASURE_BONUS = 'exit_treasure_bonus',
    GAME_INTRO = 'gameintro'
}

export enum Celebration {
    BIG_WIN = 'bigWin',
    SUPER_MEGA_WIN = 'superMegaWin',
    MEGA_WIN = 'megaWin',
    EPIC_WIN = 'epicWin',
    TOTAL_WIN = 'totalWin'
}

export enum DOServerKeys {
    FREESPIN = 'FREE_SPINS',
    TREASURE_BONUS = 'BONUS'
}

export const GF_CANVAS_SIZES = {
    DEFAULT_PORTRAIT_SCALE: 1
};

export enum GFCustomLayers {
    BACKGROUND_ANIMATIONS = 'BackgroundAnimations',
    ANTICIPATION = 'Anticipation',
    WILD_STICKY = 'WildSticky'
}



// WEBPACK FOOTER //
// ./src/names/do-names.ts